"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectParametersPage = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const antd_1 = require("antd");
const CurrentProjectProvider_1 = require("src/configeek_assets/src/components/common/provider/CurrentProjectProvider");
const PageContent_1 = require("src/configeek_assets/src/components/common/widget/PageContent");
const ProjectConfigStoreDataProvider_1 = require("src/configeek_assets/src/components/common/provider/ProjectConfigStoreDataProvider");
const PageLoaderComponent_1 = require("src/configeek_assets/src/components/common/widget/PageLoaderComponent");
const icons_1 = require("@ant-design/icons");
const ConfigKeysList_1 = require("src/configeek_assets/src/components/loggedIn/content/project/data/parameters/ConfigKeysList");
const PutProjectConfigKeyModalComponent_1 = require("src/configeek_assets/src/components/loggedIn/common/PutProjectConfigKeyModalComponent");
const isMounted_1 = __importDefault(require("src/configeek_assets/src/system/hooks/isMounted"));
const appICUtils_1 = require("src/configeek_assets/src/ic/appICUtils");
const i18_1 = require("src/configeek_assets/src/i18");
const Analytics_1 = require("src/configeek_assets/src/system/analytics/Analytics");
const AppRouter_1 = require("src/configeek_assets/src/components/common/AppRouter");
const react_router_dom_1 = require("react-router-dom");
const ProjectParametersPage = () => {
    const isMounted = (0, isMounted_1.default)();
    const currentProjectContext = (0, CurrentProjectProvider_1.useCurrentProjectContext)();
    const projectConfigStoreDataContext = (0, ProjectConfigStoreDataProvider_1.useProjectConfigStoreDataContext)();
    (0, react_1.useEffect)(() => {
        Analytics_1.Analytics.trackViewParametersPage();
    }, []);
    (0, react_1.useEffect)(() => {
        projectConfigStoreDataContext.fetchConfig();
    }, [projectConfigStoreDataContext.fetchConfig]);
    const onClickTryAgain = (0, react_1.useCallback)(() => {
        projectConfigStoreDataContext.fetchConfig();
    }, [projectConfigStoreDataContext.fetchConfig]);
    //create configKey
    const [createConfigKeyModalVisible, setCreateConfigKeyModalVisible] = (0, react_1.useReducer)((state, newState) => ({ ...state, ...newState }), { visible: false, nonce: 0 });
    const onCreateConfigKeyModalDestroy = (0, react_1.useCallback)(() => {
        if (isMounted()) {
            setCreateConfigKeyModalVisible({ visible: false });
        }
    }, [isMounted]);
    const onClickCreateKey = () => {
        setCreateConfigKeyModalVisible({ visible: true, nonce: createConfigKeyModalVisible.nonce + 1 });
    };
    const { inProgress, loaded } = projectConfigStoreDataContext.config.status;
    const hasConfKeys = projectConfigStoreDataContext.hasConfigKeys();
    const projectApiKey = currentProjectContext.projectData.view.project.projectApiKey;
    const canEditKeys = appICUtils_1.ParticipantUtils.hasProjectParameterEditAccess(currentProjectContext.projectData.view.participant);
    const createConfigKeyHeaderButton = canEditKeys ? React.createElement(antd_1.Button, { onClick: onClickCreateKey, icon: React.createElement(icons_1.PlusOutlined, null), disabled: inProgress },
        React.createElement("span", null, i18_1.i18.project.configuration.common.header.createButton)) : null;
    const createConfigKeyHeaderModal = canEditKeys ? React.createElement(PutProjectConfigKeyModalComponent_1.PutProjectConfigKeyModalComponent, { key: `createConfKey${createConfigKeyModalVisible.nonce}`, visible: createConfigKeyModalVisible.visible, onDestroy: onCreateConfigKeyModalDestroy, projectApiKey: projectApiKey, canEdit: canEditKeys }) : null;
    const refreshHeaderButton = React.createElement(antd_1.Button, { icon: React.createElement(icons_1.ReloadOutlined, null), onClick: onClickTryAgain, disabled: inProgress });
    const pageHeaderExtra = React.createElement(React.Fragment, null,
        createConfigKeyHeaderModal,
        React.createElement(antd_1.Space, null,
            createConfigKeyHeaderButton,
            refreshHeaderButton));
    const pageHeader = React.createElement(antd_1.PageHeader, { title: currentProjectContext.projectData.view.project.projectName, extra: pageHeaderExtra });
    if (!loaded) {
        return React.createElement(React.Fragment, null,
            pageHeader,
            React.createElement(PageContent_1.PageContent, null,
                React.createElement(PageContent_1.PageContent.CardSpacer, null),
                React.createElement(PageContent_1.PageContent.Card, null,
                    React.createElement(PageLoaderComponent_1.PageLoaderComponent, { marginTop: "30px" }))));
    }
    if (projectConfigStoreDataContext.config.error.isError) {
        // const error: Error = projectConfigStoreDataContext.config.error.error || new Error("unknown")
        const subTitle = React.createElement(React.Fragment, null,
            "Project configuration parameters cannot be loaded.",
            React.createElement("br", null),
            "Please try again.");
        return React.createElement(React.Fragment, null,
            pageHeader,
            React.createElement(PageContent_1.PageContent, null,
                React.createElement(PageContent_1.PageContent.CardSpacer, null),
                React.createElement(PageContent_1.PageContent.Card, null,
                    React.createElement(antd_1.Result, { title: i18_1.i18.common.error.oops.title, subTitle: subTitle, icon: React.createElement(React.Fragment, null), extra: React.createElement(antd_1.Button, { type: "primary", size: "large", onClick: onClickTryAgain, disabled: inProgress, loading: inProgress }, i18_1.i18.common.error.tryAgain) }))));
    }
    if (!hasConfKeys) {
        const createKeyButton = canEditKeys ? React.createElement(antd_1.Button, { type: "primary", size: "large", onClick: onClickCreateKey, disabled: inProgress, loading: inProgress }, i18_1.i18.project.configuration.noKeysStub.createButton) : null;
        return React.createElement(React.Fragment, null,
            pageHeader,
            React.createElement(PageContent_1.PageContent, null,
                React.createElement(PageContent_1.PageContent.CardSpacer, null),
                React.createElement(PageContent_1.PageContent.Card, null,
                    React.createElement(antd_1.Result, { title: i18_1.i18.project.configuration.noKeysStub.title, subTitle: React.createElement(React.Fragment, null,
                            React.createElement("br", null),
                            "Please integrate ",
                            React.createElement(react_router_dom_1.Link, { to: AppRouter_1.PathGenerator.project(projectApiKey, "settings") }, "confiGeek SDK"),
                            " into your project and create your first configuration key."), icon: React.createElement(React.Fragment, null), extra: createKeyButton }))));
    }
    return React.createElement(React.Fragment, null,
        pageHeader,
        React.createElement(PageContent_1.PageContent, null,
            React.createElement(PageContent_1.PageContent.CardSpacer, null),
            React.createElement(PageContent_1.PageContent.Card, null,
                React.createElement(ConfigKeysList_1.ConfigKeysList, null))));
};
exports.ProjectParametersPage = ProjectParametersPage;
